<template>

    <Head :title="__('Password expired')" />
    <div class="flex align-items-center justify-content-center min-h-screen p-3">
        <v-form name="formExpired"
                class="w-full"
                style="max-width:26rem"
                @keyup.enter="update">
            <Card>
                <template #header>
                    <div class="flex justify-content-center pt-4">
                        <Image :src="systemLogo"
                               width="140" />
                    </div>
                </template>

                <template #title>
                    <div class="text-center">{{ __('Password expired. Please change password') }}</div>
                </template>

                <template #content>
                    <Message v-if="props.rules"
                             severity="info"
                             :closable="false"
                             class="mb-4">
                        <ul class="pl-3 m-0">
                            <li v-for="(rule, index) in props.rules"
                                :key="index">
                                {{ rule }}
                            </li>
                        </ul>
                    </Message>

                    <div class="flex flex-column gap-2 mb-3">
                        <label for="current_password">{{ __('Current password') }}</label>
                        <Password inputId="current_password"
                                  size="small"
                                  class="w-full"
                                  inputClass="w-full"
                                  :feedback="false"
                                  toggleMask
                                  :invalid="!!form.errors.current_password"
                                  @input="form.errors.current_password = null"
                                  v-model="form.current_password" />
                        <small v-if="form.errors.current_password"
                               class="p-error">{{ __(form.errors.current_password) }}</small>
                    </div>

                    <div class="flex flex-column gap-2 mb-3">
                        <label for="password">{{ __('New password') }}</label>
                        <Password inputId="password"
                                  size="small"
                                  class="w-full"
                                  inputClass="w-full"
                                  :feedback="false"
                                  toggleMask
                                  v-model="form.password" />
                        <small v-if="form.errors.password"
                               class="p-error">{{ __(form.errors.password) }}</small>
                    </div>

                    <div class="flex flex-column gap-2 mb-4">
                        <label for="password_confirmation">{{ __('Confirm new password') }}</label>
                        <Password inputId="password_confirmation"
                                  size="small"
                                  class="w-full"
                                  inputClass="w-full"
                                  :feedback="false"
                                  toggleMask
                                  v-model="form.password_confirmation" />
                    </div>

                    <Button @click="update"
                            :label="__('Set new password')"
                            icon="pi pi-sign-in"
                            class="w-full" />

                    <input type="hidden"
                           id="token"
                           name="token"
                           v-model="form.token" />
                </template>
            </Card>
        </v-form>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { Head } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3'

import Button from 'primevue/button';
import Password from 'primevue/password';
import Card from 'primevue/card';
import Message from 'primevue/message';

import Layout from '@layouts/LayoutNoMenuNoFooter.vue'
import Image from '@helper/Image.vue'
import { __ } from '@helper/utils.js'
import { systemLogo, startSplash } from '@helper/constants.js'

defineOptions({ layout: Layout })

const props = defineProps({
    user_id: String,
    email: String,
    rules: Object,
})
// -----------------------------------------------------

const form = useForm({ current_password: '', password: '', password_confirmation: '' })

// -----------------------------------------------------

const update = () => {
    form.post(route('password-expired-update', { 'user_id': props.user_id, 'email': props.email }))
}

// -----------------------------------------------------
</script>

<style lang="scss"
       scoped></style>
